import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Badge, BadgeText } from '../badge'
import { type StatusBadgeProps } from './StatusBadge.types'
import { statusBadgeVariants } from './variants'

const sizeClasses: Record<NonNullable<StatusBadgeProps['size']>, string> = {
    sm: 'px-1.5 py-0.5 rounded',
    md: 'px-2 py-1 rounded-md',
}

// Literal sizes, not the `text-label-*` theme keys: tailwind-merge reads a
// named `text-*` token as a colour, so the size lost to the status ink merged
// next to it and never reached the label.
const sizeTextClasses: Record<NonNullable<StatusBadgeProps['size']>, string> = {
    sm: 'text-[0.75rem] leading-[1rem]',
    md: 'text-[0.875rem] leading-[1.25rem]',
}

export function StatusBadge({ status, label, size = 'md', className }: StatusBadgeProps) {
    const { bg, text } = statusBadgeVariants(status)
    return (
        <Badge className={twMerge(sizeClasses[size], bg, className)}>
            <BadgeText className={twMerge('normal-case font-bold', sizeTextClasses[size], text)}>
                {label}
            </BadgeText>
        </Badge>
    )
}
